import React, { createContext, useReducer, useCallback } from 'react';
import {
    CategoryShowcaseState,
    CategoryShowcaseAction,
    CategoryMasterItem,
} from '../types/categoryMaster.types';
import { categoryShowcaseService } from '../services/categoryShowcaseService';

const initial: CategoryShowcaseState = {
    categories: [],
    loading: false,
    error: null,
};

function reducer(state: CategoryShowcaseState, action: CategoryShowcaseAction): CategoryShowcaseState {
    switch (action.type) {
        case 'FETCH_START':
            return { ...state, loading: true, error: null };
        case 'FETCH_SUCCESS':
            return { ...state, loading: false, categories: action.payload };
        case 'FETCH_ERROR':
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
}

interface CategoryShowcaseContextValue {
    state: CategoryShowcaseState;
    fetchPublic: () => Promise<void>;
}

export const CategoryShowcaseContext = createContext<CategoryShowcaseContextValue | null>(null);

export const CategoryShowcaseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initial);

    const fetchPublic = useCallback(async () => {
        dispatch({ type: 'FETCH_START' });
        try {
            const { data } = await categoryShowcaseService.fetchPublic();
            const categories: CategoryMasterItem[] = (data as { categories: CategoryMasterItem[] }).categories;
            dispatch({ type: 'FETCH_SUCCESS', payload: categories });
        } catch {
            dispatch({ type: 'FETCH_ERROR', payload: 'Failed to load categories' });
        }
    }, []);

    return (
        <CategoryShowcaseContext.Provider value={{ state, fetchPublic }}>
            {children}
        </CategoryShowcaseContext.Provider>
    );
};
